module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "not-found-view"
    }
  }, [_c('div', {
    attrs: {
      "id": "wideContent"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "boxContent"
  }, [_c('h1', [_vm._v("Stránka nebyla nenalezena")]), _vm._v(" "), _c('p', [_vm._v("\n          Stránka, na kterou jste se pokusili přejít neexistuje.\n        ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Klikněte pro přechod na hlavní stránku webu.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "500px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77d69f04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/NotFoundView.vue
// module id = 81
// module chunks = 0